/**
 * Constants for EMR systems and their logos
 */
export const EMRS = [
  {
    name: 'Athena Health',
    image: require('../assets/img/emrs/AthenaFull.png'),
  },
  {
    name: 'CentralReach',
    image: require('../assets/img/emrs/CentralReach.png'),
  },
  {
    name: 'Charm Health',
    image: require('../assets/img/emrs/CharmHealth.png'),
  },
  { name: 'Clinicient', image: require('../assets/img/emrs/Clinicient.png') },
  {
    name: 'Comprehend Health',
    image: require('../assets/img/brand/WebsiteLogoGreen.png'),
  },
  {
    name: 'Comprise Health',
    image: require('../assets/img/emrs/CompriseHealth.png'),
  },
  { name: 'Cora Health', image: require('../assets/img/emrs/CoraHealth.png') },
  { name: 'Empower', image: require('../assets/img/emrs/EmpowerFull.png') },
  { name: 'Fusion', image: require('../assets/img/emrs/Fusion.png') },
  { name: 'HelloNote', image: require('../assets/img/emrs/HelloNote.png') },
  { name: 'Heno', image: require('../assets/img/emrs/Heno.png') },
  { name: 'IntakeQ', image: require('../assets/img/emrs/IntakeQ.png') },
  { name: 'Jane', image: require('../assets/img/emrs/JaneApp.png') },
  { name: 'Kinser', image: require('../assets/img/emrs/Kinser.png') },
  {
    name: 'NetHealth',
    image: require('../assets/img/emrs/NetHealth.png'),
  },
  {
    name: 'Practice Perfect',
    image: require('../assets/img/emrs/PracticePerfectFull.png'),
  },
  {
    name: 'Practice Pro',
    image: require('../assets/img/emrs/PracticePro.png'),
  },
  { name: 'Prompt', image: require('../assets/img/emrs/Prompt.png') },
  {
    name: 'PT Everywhere',
    image: require('../assets/img/emrs/PTEverywhere.png'),
  },
  { name: 'Raintree', image: require('../assets/img/emrs/Raintree.png') },
  { name: 'Stride', image: require('../assets/img/emrs/Stride.png') },
  {
    name: 'TheraOffice',
    image: require('../assets/img/emrs/Theraoffice.jpeg'),
  },
  { name: 'WebPT', image: require('../assets/img/emrs/WebPT.png') },
  { name: 'WebPT2', image: require('../assets/img/emrs/WebPT.png') },
];

/**
 * Constants for different types of notes and their images
 */
export const NOTE_TYPES = [
  {
    name: 'Daily Note',
    image: require('../assets/img/noteTypes/DailyNote.png'),
  },
  {
    name: 'Discharge Summary',
    image: require('../assets/img/noteTypes/DischargeSummary.webp'),
  },
  { name: 'Follow Up', image: require('../assets/img/noteTypes/FollowUp.png') },
  {
    name: 'Initial Evaluation',
    image: require('../assets/img/noteTypes/InitialEvaluation.png'),
  },
  {
    name: 'Initial Examination',
    image: require('../assets/img/noteTypes/InitialExam.png'),
  },
  {
    name: 'Progress Note',
    image: require('../assets/img/noteTypes/ProgressNote.png'),
  },
  {
    name: 'Re-Evaluation',
    image: require('../assets/img/noteTypes/ReEval.png'),
  },
  { name: 'SOAP Note', image: require('../assets/img/noteTypes/SoapNote.png') },
  {
    name: 'Standard Visit',
    image: require('../assets/img/noteTypes/StandardVisit.png'),
  },
  {
    name: 'General Evaluation',
    image: require('../assets/img/noteTypes/WebApp.png'),
  },
  {
    name: 'Web App Evaluation',
    image: require('../assets/img/noteTypes/WebApp.png'),
  },
];

/**
 * Constants for different healthcare professions and their images
 */
export const PROFESSION_TYPES = [
  {
    name: 'Physical Therapist',
    image: require('../assets/img/professions/PhysicalTherapist.png'),
  },
  {
    name: 'Occupational Therapy',
    image: require('../assets/img/professions/OccupationalTherapy.png'),
  },
  { name: 'Nurse', image: require('../assets/img/professions/Nurse.png') },
  {
    name: 'Mental Health Therapist',
    image: require('../assets/img/professions/MentalHealthTherapist.png'),
  },
  {
    name: 'Chiropractor',
    image: require('../assets/img/professions/Chiropractor.png'),
  },
  { name: 'Trainer', image: require('../assets/img/professions/Trainer.png') },
  {
    name: 'Orthopedic',
    image: require('../assets/img/professions/Orthopedic.png'),
  },
];

/**
 * Profession options for dropdowns
 */
export const PROFESSION_OPTIONS = [
  'Chiropractor',
  // Not first: CompanyNoteSettings falls back to PROFESSION_OPTIONS[0].
  'Board Certified Behavior Analyst (BCBA)',
  'Certified Occupational Therapy Assistant',
  'Mental Health Therapist',
  'Nurse',
  'Occupational Therapist',
  'Orthopedic',
  'Physical Therapist',
  'Physical Therapy Assistant',
  'Speech-Language Pathologist',
  'Student',
  'Trainer',
  'Other',
];

/**
 * Speciality options for dropdowns (from Register.js)
 */
export const SPECIALITY_OPTIONS = [
  'Feeding',
  'Hand Therapy',
  'Pediatrics',
  'Pelvic health',
  'Other',
];

/**
 * EMR options for dropdowns - based on actual integrations with working chrome services
 * Only includes EMRs that have corresponding Inject.ts files in chromeServices/
 */
export const EMR_OPTIONS = [
  'Athena Health',
  'CentralReach',
  'Charm Health',
  'Clinicient',
  'Comprise Health',
  'Cora Health',
  'Empower',
  'Emerge',
  'Fusion',
  'HelloNote',
  'Heno',
  'IntakeQ',
  'Jane',
  'Kinser',
  'NetHealth',
  'Practice Perfect',
  'Practice Pro',
  'Prompt',
  'PT Everywhere',
  'Raintree',
  'StrideThera',
  'TheraOffice',
  'WebPT 1.0',
  'WebPT 2.0',
  'Other',
  'None',
];

/**
 * EMR tutorial video mapping
 * Maps EMR names to their onboarding/tutorial video URLs
 */
export const EMR_VIDEO_MAP = {
  'Athena Health':
    'https://www.loom.com/share/481f88429f9c4ac8a3e894f67aef6a46?sid=f6959c26-f30a-4b16-bad4-d3fb840ee462',
  Clinicient: 'https://www.loom.com/share/e69d738de5d645e0a087a13fd3980d05',
  'Cora Health':
    'https://www.loom.com/share/8e7c0c87b1d240daa3a57d37617cfed8?sid=55c6b623-0288-4a50-8919-9cf581cf5550',
  Empower: 'https://youtu.be/1Qk8c2y-2x4?si=eRqJhBMRMgHjlGWI',
  Fusion:
    'https://www.loom.com/share/2cb5ae70c5bb40e98b3563142c11698d?sid=2b538afc-3d2d-4f19-af5c-ab3ff4ef6140',
  HelloNote:
    'https://www.loom.com/share/82bc6fae154c4670a11507fb19deb11b?sid=21edd85a-cbee-4ac7-b14a-be665660c681',
  Heno: 'https://www.loom.com/share/a2eb525d014c4d929f31edcd2dabc22e?sid=7164d6ad-ed88-4664-b35d-582f2547ac10',
  IntakeQ:
    'https://www.loom.com/share/f288b006e6624eacb21483787911ab3b?sid=8c32744d-ef78-4254-86e3-9d5824976edd',
  Jane: 'https://www.loom.com/share/64a29ace93e54971a4b4cf96e8d4d267?sid=5573c218-1597-451c-b6db-496531a92757',
  NetHealth:
    'https://www.loom.com/share/19432f4aa1d44bc4ae321b5b110968a0?sid=740b1524-5a5a-4e3e-9e1d-71dfb1fef664',
  'Practice Perfect': 'https://youtu.be/HyChF4YlZJQ',
  'Practice Pro':
    'https://www.loom.com/share/46247a21aba14ec380910e508794f539?sid=6ea9ab01-9d78-45b8-a5e2-9d37c47bddbc',
  Prompt:
    'https://www.loom.com/share/69d386f31d8d449f87d5ed5c1bdd2821?sid=c6dfc52e-b153-458b-9dcd-f4355e15576b',
  'PT Everywhere':
    'https://www.loom.com/share/989635131f514097a1c8dfed7d7327ef?sid=ce3e2043-5ee6-459d-9c10-37e7ea7ad709',
  Raintree:
    'https://www.loom.com/share/2f3b99da71864e5781373158b3f6ac33?sid=a70071a1-3583-40b4-aad7-b379e5ab7f1f',
  StrideThera:
    'https://www.loom.com/share/c4b4db4f1b944fe383994d8357908f25?sid=124b93b3-f5aa-438a-b749-45364ba477c7',
  TheraOffice:
    'https://www.loom.com/share/6a92ed76706948c59be1e105bff50b9c?sid=e0e0b82d-0929-4bf2-9c6a-f7ed6f9b7593',
  'WebPT 1.0': 'https://youtu.be/ym_hFw7UhIY?feature=shared',
  'WebPT 2.0': 'https://youtu.be/rd_s8-w7lt0?feature=shared',
};

export const EMR_LOGIN_URLS = {
  'Athena Health': 'https://athenahealth.com',
  CentralReach: 'https://login.centralreach.com/login',
  'Charm Health': 'https://ehr.charmtracker.com',
  Clinicient: 'https://insight.clinicient.com/Security/login',
  'Cora Health': 'https://sapphire.corahealth.com/login',
  Empower: 'https://app.empoweremr.com/login',
  Emerge: 'https://beta.ehr.software/login',
  Fusion: 'https://app.fusionwebclinic.com/login',
  HelloNote: 'https://hellonote.com/login',
  Heno: 'https://heno-prod2.com/',
  IntakeQ: 'https://intakeq.com/signin/',
  Jane: 'https://comprehendptai.janeapp.com/admin',
  Kinser: 'http://www.kinnser.net/login.cfm',
  NetHealth: 'https://centralidentityprd.casamba.net/account/login',
  'Practice Perfect':
    'https://app.practiceperfectemr.com/emrV2/662/#/login/v2/sample30',
  'Practice Pro': 'https://app.ptpracticepro.com/PTProDemo/login',
  Prompt: 'https://go.promptemr.com/login',
  'PT Everywhere': 'https://app.pteverywhere.com/login',
  Raintree: 'https://raintreeinc.com/login',
  StrideThera: 'https://stridethera.com/login',
  TheraOffice: 'https://nx.theraofficeweb.com/',
  WebPT: 'https://app.webpt.com/',
  WebPT2: 'https://emr.webpt.com/',
  'WebPT 1.0': 'https://app.webpt.com/',
  'WebPT 2.0': 'https://app.webpt.com/',
  'Comprise Health':
    'https://emr.comprisehealth.net' ||
    'https://u2vtbdkgke.us-east-1.awsapprunner.com/',
};

export const GETTING_STARTED_URL_MAP = {
  default:
    'https://comprehendpt.notion.site/Guide-How-Comprehend-Fills-Out-Your-Notes-in-the-EMR-1793e623253145b685260f5c68d6d88b',
  Clinicient:
    'https://comprehendpt.notion.site/How-to-Use-Comprehend-Scribe-with-Clinicient-InsightGO-2e868e7a57a98018b6cac55c1bd2ec7f',
  Empower:
    'https://comprehendpt.notion.site/Comprehend-Health-Empower-EMR-07bf9272cf9544b19534a97d2493ac30',
  InsightGO:
    'https://comprehendpt.notion.site/How-to-Use-Comprehend-Scribe-with-Clinicient-InsightGO-2e868e7a57a98018b6cac55c1bd2ec7f',
  WebPT: 'https://share.articulate.com/xSbWWw8EArA3FC0M6LywS',
  'WebPT 1.0': 'https://share.articulate.com/xSbWWw8EArA3FC0M6LywS',
  'WebPT 2.0':
    'https://comprehendpt.notion.site/How-to-Use-Comprehend-s-Scribe-with-WebPT-SOAP-2-0-25368e7a57a980b5a45ffd73813ad315?source=copy_link',
  StrideThera:
    'https://help.comprehendhealth.ai/en/article/using-comprehend-with-stride-1vib8cl/?bust=1775673501317',
};
